// src/LayerPopup.jsx
import React, { useEffect, useState } from "react";
import "./Aishop.css";
import "./WalletModal.css"; 

export default function LayerPopup({ show, onClose, onConnectHavah, onConnectXPLA, onConnectWalletConnect, children }) {
  const [isXplaInstalled, setIsXplaInstalled] = useState(false);

  useEffect(() => {
    setIsXplaInstalled(typeof window.xplaWallets !== "undefined");
  }, []);
	
  if (!show) return null;

 return (
    <div className="wallet-modal-bg" onClick={onClose}>
      <div className="wallet-modal" onClick={e => e.stopPropagation()}>
        <div className="wallet-modal-header">
          <span className="wallet-modal-title">Connect your wallet</span>
          <button className="wallet-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="wallet-modal-list">
          <div className="wallet-modal-item">
            <span className="wallet-modal-icon" style={{background: "#00bcd4"}}>
              {/* 예시: SVG 아이콘 */}
              <img src="https://cdn-icons-png.flaticon.com/512/616/616494.png" alt="HAVAH" width={32} height={32} />
            </span>
            <span className="wallet-modal-label">HAVAH</span>
            <button className="wallet-modal-action" onClick={onConnectHavah}>Install</button>
          </div>
          <div className="wallet-modal-item">
            <span className="wallet-modal-icon" style={{background: "#4caf50"}}>
              <img src="https://cdn-icons-png.flaticon.com/512/616/616408.png" alt="XPLA Vault" width={32} height={32} />
            </span>
            <span className="wallet-modal-label">XPLA Vault</span>
            <button className="wallet-modal-action" onClick={onConnectXPLA}>Install</button>
          </div>
          <div className="wallet-modal-item">
            <span className="wallet-modal-icon" style={{background: "#3f51b5"}}>
              <img src="https://cdn-icons-png.flaticon.com/512/616/616408.png" alt="Wallet Connect" width={32} height={32} />
            </span>
            <span className="wallet-modal-label">Wallet Connect</span>
            <button className="wallet-modal-action" onClick={onConnectWalletConnect}>Connect</button>
          </div>
        </div>
              {/* XPLA Vault 설치 여부 안내 */}
        {isXplaInstalled ? (
          <div style={{ color: "green", marginBottom: 16 }}>
            XPLA Vault Wallet이 설치되어 있습니다.
          </div>
        ) : (
          <div style={{ color: "red", marginBottom: 16 }}>
            XPLA Vault Wallet이 설치되어 있지 않습니다. <br />
            <a
              href="https://chromewebstore.google.com/detail/xpla-vault-wallet/ocjobpilfplciaddcbafabcegbilnbnb"
              target="_blank"
              rel="noopener noreferrer"
            >
              설치하러 가기
            </a>
          </div>
        )}
        {children}
        
        
        
      </div>
    </div>
    
    
    
    
  );
}